import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customprice',
    standalone: false
})
export class CustompricePipe implements PipeTransform {

  transform(value: any, suffix = '€'): unknown {
    // console.log(value);
    if (value === null || value === undefined) {
      return '';
    }


    // if (createMode) {
    //   let val = value.replace(',', '.').replace(/[^0-9\.]/, '')
    //   // ev.target.value = Number(ev.target.value).toFixed(2).replace('.', ',');
    //   if (val) {
    //     let num = val.match(/\d+\.\d{1,2}|\d+/)
    //     if (num && num[0]) {
    //       value = parseInt((parseFloat(num[0]) * 100).toString(), 10);
    //     } else {
    //       return '';
    //     }
    //   } else {
    //     return '';
    //   }
    // }

    const initValue = parseInt(value.toString(), 10);
    let newValue = initValue;
    newValue /= 100;
    if (initValue === 0) {
      return 'GRATIS';
    } else if (initValue % 100 === 0) {
      return newValue + suffix;
    } else if (initValue % 10 === 0) {
      return newValue.toFixed(1).replace('.', ',') + suffix;
    } else {
      return newValue.toFixed(2).replace('.', ',') + suffix;
    }
  }

}
